import { render } from "./ProposalLifeCircleModal.vue?vue&type=template&id=2cfd725f"
import script from "./ProposalLifeCircleModal.vue?vue&type=script&lang=js"
export * from "./ProposalLifeCircleModal.vue?vue&type=script&lang=js"

import "./ProposalLifeCircleModal.vue?vue&type=style&index=0&id=2cfd725f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__